import {
  CircularProgress,
  Dialog,
  DialogContent,
  type DialogProps,
  Flex,
  Text,
} from '@shared/components';

interface ImportExamineesFromWRModalProps extends DialogProps {
  open: boolean;
}

export default function ImportExamineesFromWRModal(
  props: Readonly<ImportExamineesFromWRModalProps>,
) {
  const { open: isOpen } = props;

  return (
    <Dialog open={isOpen} sx={{ '& .MuiPaper-root': { width: '378px' } }}>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <CircularProgress />
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'center' })}
        >
          <Text variant='h5'>กำลังนำเข้ารายชื่อผู้มีสิทธิสอบ</Text>
          <Text color='secondary'>กรุณารอสักครู่ ระบบกำลังนำเข้าข้อมูลจาก WR</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
